export enum REFRIGERATOR_OPTIONS {
    BROWSE_REFRIGERATORS = 'BROWSE_REFRIGERATORS',
    SUPPLY_REFRIGERATORS = 'SUPPLY_REFRIGERATORS',
    NO_REFRIGERATORS = 'NO_REFRIGERATORS',
}
